var _a, _b, _c, _d, _e, _f;
import { CommunicationsEventKind, CommunicationsEvent } from './event';
import { noop } from '../../../utilities/noop';
/**
 * The communication handler methods.
 */
var ContainerCommunicationHandlerMethods = /** @class */ (function () {
    function ContainerCommunicationHandlerMethods() {
        /**
         * Call the container to signal that the content finished mounting.
         */
        this[_a] = noop;
        /**
         * Call the container to signal an update is about to happen.
         */
        this[_b] = noop;
        /**
         * Call the container to signal an update finished.
         */
        this[_c] = noop;
        /**
         * Call the container to signal dispose started.
         */
        this[_d] = noop;
        /**
         * Call the container to signal the component has disposed(almost).
         */
        this[_e] = noop;
        /**
         * Call the container to signal the component has disposed(almost).
         */
        this[_f] = noop;
    }
    return ContainerCommunicationHandlerMethods;
}());
export { ContainerCommunicationHandlerMethods };
_a = CommunicationsEventKind.Mounted, _b = CommunicationsEventKind.BeforeUpdate, _c = CommunicationsEventKind.Updated, _d = CommunicationsEventKind.BeforeDispose, _e = CommunicationsEventKind.Disposed, _f = CommunicationsEventKind.Data;
/**
 * Handle the communications on the child component side.
 */
var ContainerCommunicationHandler = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param communicationsManager A communications manager.
     * @param handlerMethods A collection of handler methods.
     */
    function ContainerCommunicationHandler(communicationsManager, handlerMethods) {
        var _this = this;
        this.communicationsManager = communicationsManager;
        this.handlerMethods = handlerMethods;
        this.communicationsManager.setEventReceivedCallback(function (e) {
            _this.handleEvent(e);
        });
        this.disposed = false;
    }
    /**
     * Core functionality for handling the incoming events.
     *
     * @param e The event.
     */
    ContainerCommunicationHandler.prototype.handleEventCore = function (e) {
        if (!this.handlerMethods)
            return;
        var method = this.handlerMethods[e.kind];
        if (!method)
            return;
        method(e.data);
    };
    /**
     * Handle the incoming communications event.
     *
     * @param e The event
     */
    ContainerCommunicationHandler.prototype.handleEvent = function (e) {
        this.handleEventCore(e);
    };
    /**
     * Method invoked to dispose of the handler.
     */
    ContainerCommunicationHandler.prototype.dispose = function () {
        var _g;
        if (this.disposed)
            return;
        this.disposed = true;
        (_g = this.communicationsManager) === null || _g === void 0 ? void 0 : _g.dispose();
        this.communicationsManager = null;
        this.handlerMethods = null;
    };
    /**
     * Send a message.
     *
     * @param event The message.
     */
    ContainerCommunicationHandler.prototype.send = function (event) {
        var _g;
        (_g = this.communicationsManager) === null || _g === void 0 ? void 0 : _g.send(event);
    };
    /**
     * Send data.
     *
     * @param data The data to send.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ContainerCommunicationHandler.prototype.sendData = function (data) {
        var _g;
        var event = new CommunicationsEvent(CommunicationsEventKind.Data);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        event.data = data;
        (_g = this.communicationsManager) === null || _g === void 0 ? void 0 : _g.send(event);
    };
    /**
     * Request that the content begins disposing.
     */
    ContainerCommunicationHandler.prototype.requestContentDispose = function () {
        this.send(new CommunicationsEvent(CommunicationsEventKind.BeforeDispose));
    };
    return ContainerCommunicationHandler;
}());
export { ContainerCommunicationHandler };
//# sourceMappingURL=containerHandler.js.map